import React from 'react'
import { IIconProps as IProps } from './IIconProps'

/**
 * Two overlapping sheets: the library's own copy icon, for taking a copy of
 * what a block says. `Copy` is a chain — it marks copying a *link* — and
 * `Duplicate` carries a plus, which is making a second one rather than taking
 * this one with you.
 */
const IconCopyText = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="8 8 72 72"
    fill="none"
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.069 8C75.5537 8 80 12.4462 80 17.931V50.2069C80 55.52 75.8275 59.8583 70.5805 60.1246L70.069 60.1379H60.1379V70.069C60.1379 75.3821 55.9655 79.7204 50.7185 79.9867L50.2069 80H17.931L17.4194 79.9867C12.3419 79.729 8.27102 75.6581 8.01334 70.5805L8 70.069V37.7931C8 32.3083 12.4463 27.8621 17.931 27.8621H27.8621V17.931C27.8621 12.4462 32.3083 8 37.7931 8H70.069ZM37.7931 15.4483C36.4219 15.4483 35.3103 16.5598 35.3103 17.931V27.8621H50.2069C55.6917 27.8621 60.1379 32.3083 60.1379 37.7931V52.6897H70.069C71.4401 52.6897 72.5517 51.5781 72.5517 50.2069V17.931C72.5517 16.5598 71.4401 15.4483 70.069 15.4483H37.7931ZM35.3103 35.3103H27.8621H17.931C16.5599 35.3103 15.4483 36.4219 15.4483 37.7931V70.069C15.4483 71.4402 16.5599 72.5517 17.931 72.5517H50.2069C51.5781 72.5517 52.6897 71.4402 52.6897 70.069V60.1379V52.6897V37.7931C52.6897 36.4219 51.5781 35.3103 50.2069 35.3103H35.3103Z"
    />
  </svg>
)

export default IconCopyText
